<div class="vo-central-content vo-body-regular-14">
  <div class="heading-image"></div>
  <div class="login-extended-functionality-container p-0 mx-auto text-center">
    <div class="vo-heading-bold-24 mb-30 mt-60" [innerHTML]="referenceDataLabels.ExpiredPassword | localizeLabel"></div>
    <div
      class="vo-body-regular-14 my-30"
      [innerHTML]="referenceDataLabels.ExpiredPasswordDescription|localizeLabel"
    ></div>

    <form #changeExpiredPasswordForm="ngForm">
      <div *ngIf="errorMessage" class="vo-body-regular-14 text-center my-30" [innerHTML]="errorMessage"></div>
      <div [ngClass]="{'has-errors': changeExpiredPasswordForm.submitted && newPasswordInput.invalid }">
        <div
          *ngIf="changeExpiredPasswordForm.submitted && newPasswordInput.invalid"
          class="error-message"
          [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage : 'NewPassword'"
        ></div>
        <boi-validation-error-generic
          class="d-block my-15"
          [validationErrors]="validationErrors"
          [propertyNames]="['PasswordToHash', 'PasswordMinimumLength', 'PasswordMissingLowerCharacter', 'PasswordMissingUpperCharacter', 'PasswordMissingSpecialCharacter', 'PasswordUsedPreviously']"
        >
        </boi-validation-error-generic>
        <boi-text-input
          class="field-input-full-width field-text-center"
          [cssClasses]="'label-top label-weight-bold'"
          [required]="true"
          name="newPassword"
          #newPasswordInput="ngModel"
          [(ngModel)]="resetPasswordDto.NewPassword"
          [labelName]="referenceDataLabels.UserResetPasswordNew"
          [canShowPassword]="true"
          [type]="'password'"
        >
        </boi-text-input>
      </div>

      <boi-password-strength
        class="password-strength__container mb-30"
        [passwordToCheck]="resetPasswordDto.NewPassword"
      >
      </boi-password-strength>

      <div
        [ngClass]="{'has-errors': changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
  ((confirmedNewPasswordInput.errors | firstKey) === 'required' || (confirmedNewPasswordInput.errors | firstKey) === 'mustMatch')}"
      >
        <div
          *ngIf="changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
  (confirmedNewPasswordInput.errors | firstKey) === 'required'"
          class="error-message"
          [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage : 'RetypedNewPassword'"
        ></div>

        <div
          *ngIf="changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
(confirmedNewPasswordInput.errors | firstKey) === 'mustMatch'"
          class="error-message"
          [innerHTML]="referenceDataConstants.ERROR_MESSAGE_EQ000 | localizeErrorMessage: 'RetypedNewPassword'"
        ></div>

        <boi-text-input
          class="field-input-full-width field-text-center"
          [cssClasses]="'label-top label-weight-bold'"
          [required]="true"
          name="confirmedNewPassword"
          #confirmedNewPasswordInput="ngModel"
          [(ngModel)]="resetPasswordDto.ConfirmedNewPassword"
          [labelName]="referenceDataLabels.UserResetPasswordRepeatNew"
          [canShowPassword]="true"
          [boiMustMatch]="resetPasswordDto.NewPassword"
          [type]="'password'"
        >
        </boi-text-input>
      </div>

      <div class="align-items-center d-flex flex-column my-30 w-100">
        <button
          class="vo-primary-button-1 mb-30 w-100"
          (click)="changeExpiredPassword(changeExpiredPasswordForm)"
          [innerHTML]="referenceDataLabels.UserResetPasswordSave|localizeLabel"
        ></button>
        <a class="vo-link" (click)="goBack()" [innerHTML]="referenceDataLabels.BackButtonText | localizeLabel"> </a>
      </div>
    </form>
  </div>
</div>